import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import {
  CandidateContactInfo,
  MojoExternalCandidateContactInfoService,
} from 'mojo-external-candidate-contact-info';

@Injectable({
  providedIn: 'root',
})
export class ContactService extends ApiService implements MojoExternalCandidateContactInfoService {
  constructor() {
    super();
    this.url = '';
  }

  loadExternalCandidateContactInfo(id: string): Observable<CandidateContactInfo> {
    return this.get({ url: `contact?id=${id}` });
  }

  canUseCredit(): Observable<boolean> {
    return this.get({ url: 'contact/canUseCredit' });
  }

  enrichExternalCandidateContactInfo(id: string): Observable<CandidateContactInfo> {
    return this.post({ url: `contact/enrich?id=${id}` });
  }
}
